import React, { useEffect, useRef } from 'react';
import Text from '~components/atoms/Text';
import CustomSkeleton from '~components/atoms/Skeleton';

import { useAppSelector } from '~redux/hooks';
import { FundTypeEnum, SilverTypeEnum } from '~utils/enums';

import * as Styles from './_physicalSilverPricingTable.module.scss';

const PhysicalSilverPricingTable = () => {
    const dashboardSilverProductPricing = useAppSelector(state => state.dashboard.dashboardSilverProductPricing);
    const loading = useAppSelector(state => state.dashboard.loadings.getDashboardSilverProductPricing);
    const error = useAppSelector(state => state.dashboard.errors.getDashboardSilverProductPricing);

    // Only true until the first fetch completes (success or error)
    const isInitialLoad = useRef(true);

    useEffect(() => {
        if (!loading) {
            isInitialLoad.current = false;
        }
    }, [loading]);

    const tableHeader = [
        'Denomination',
        'Bank Sell (MYR) per gram',
        'Bank Buy (MYR) per gram',
    ];

    const physicalSilverPricing = dashboardSilverProductPricing.filter(product => product.silverType === SilverTypeEnum.PhysicalSilver && product.fundType === FundTypeEnum.Islamic);

    const hasLoaded = useRef(false);

    useEffect(() => {
        if (!loading) {
            hasLoaded.current = true;
        }
    }, [loading]);

    const renderTableHeader = () => {
        return tableHeader.map((header, index) => {
            return (
                <th key={index}>
                    {header}
                </th>
            );
        });
    };

    const renderTableBody = () => {
        // Show skeleton until first fetch has completed
        if (!hasLoaded.current) {
            return (
                <tr>
                    <td colSpan={3}>
                        <CustomSkeleton height={40} />
                    </td>
                </tr>
            );
        }

        if (error) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label={error}
                            isError
                        />
                    </td>
                </tr>
            );
        }

        if (!physicalSilverPricing.length) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label='No data found'
                            isError
                        />
                    </td>
                </tr>
            );
        }
        return physicalSilverPricing.map((product, index) => {
            return (
                <tr key={index}>
                    <td>{product.productName}</td>
                    <td>{typeof product.sellPrice === 'number' ? (Math.round(product.sellPrice * 100) / 100).toFixed(2) : '-'}</td>
                    <td>{typeof product.buyPrice === 'number' ? (Math.round(product.buyPrice * 100) / 100).toFixed(2) : '-'}</td>
                </tr>
            );
        });
    };

    return (
        <div className={Styles.container}>
            <Text
                label='Affin Silver-I'
                className={Styles.title}
                isBold
            />

            <table className={Styles['table-container']}>
                <thead>
                    <tr>
                        {renderTableHeader()}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colSpan={3} />
                    </tr>
                    {renderTableBody()}
                </tbody>
            </table>
        </div>
    );
};

export default PhysicalSilverPricingTable;
